import React, {useEffect} from 'react';
import {Switch} from 'antd';
import {useDispatch} from "react-redux";
import {falseWebsite, setWebsite} from "../../redux/website/websiteActions";
import {useLocation} from "react-router-dom";

const SwitchWebsite = () => {

    const dispatch = useDispatch()

    function onChange(checked) {
        dispatch(setWebsite(checked))
    }
    const location = useLocation()
    useEffect(() => {
        if (location.path !== '/'){
            dispatch(falseWebsite())
        }
    }, [location.path])

    return (
        <div className="switch_box">
            <label>
                <Switch
                    defaultChecked={false}
                    onChange={onChange}
                />
                Website
            </label>
        </div>
    );
};

export default SwitchWebsite;